import request from '@/utils/request'

// 获取全部短信历程
export function getSmsHistoryList(params) {
    return request({
        url: '/smsHistory/smsHistoryList',
        method: 'get',
        params: params,
    })
}

// 获取全部短信
export function getSmsAllHistoryList(params) {
    return request({
        url: '/smsHistory/smsAllHistoryList',
        method: 'get',
        params: params,
    })
}


// WEBPACK FOOTER //
// ./src/api/smsHistory.js